import LoaderWrapper from '@/components/ui/LoaderWrapper/LoaderWrapper.tsx';
import NotLoggedIn from '@/router/middleware/NotLoggedIn.tsx';
import IsLoggedIn from '@/router/middleware/IsLoggedIn.tsx';
import IsOnboardingCompleted from '@/router/middleware/IsOnboardingCompleted.tsx';
import HasSubscription from '@/router/middleware/hasSubscription.tsx';

const middlewareConfig = {
  middlewaresMap: {
    notLoggedIn: <NotLoggedIn />,
    loggedIn: <IsLoggedIn />,
    onboardingCompleted: <IsOnboardingCompleted />,
    hasSubscription: <HasSubscription />,
  },
  loader: <LoaderWrapper isLoading className="h-screen" />,
} as const;

export type MiddlewareType = keyof (typeof middlewareConfig)['middlewaresMap'];

export default middlewareConfig;
